module.exports = __webpack_public_path__ + "static/media/i1.af055f41.png";